import { LOADING_REFERENCES_CONTEXT, RECEIVED_REFERENCES_CONTEXT, RECEIVED_REFERENCES_CONTEXT_FAILED } from '../types';
import { createFetcher } from '../utils';
import { identificationType } from '../../constants';

export default {
  urlFormatter: {
    [identificationType.pii]: ({ pii, token }) => `/enhancements/article/document-id/${pii}/context/references?token=${token}`,
    [identificationType.doi]: ({ doi, token }) => `/enhancements/article/document-id/${doi}/context/references?token=${token}`,
  },
  fetch: createFetcher(
    LOADING_REFERENCES_CONTEXT, RECEIVED_REFERENCES_CONTEXT, RECEIVED_REFERENCES_CONTEXT_FAILED,
  ),
};
